import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import GradeProgressData from './component'
import { ALL_LESSONS_KEY } from './constants'
import { selectors as licenseSelectors } from 'store/licenseManager'

const GradeProgressDataContainer = ({ lessonSelectedRow, ...passThrough }) => {
  const selectedTab = lessonSelectedRow?.selectedUnitTab ?? ALL_LESSONS_KEY
  return (
    <GradeProgressData
      {...passThrough}
      key={`grade-${passThrough.grade}-progress`}
      selectedTab={selectedTab}
    />
  )
}

const mapStateToProps = (state, { siteId }) => {
  const {
    userSessionManager: {
      adminDashboard: { lessons },
    },
  } = state
  const k8SitesWithDwb = licenseSelectors.selectActiveAdminK8SitesWithDwb(state)

  return {
    hasK8DwbAccess: k8SitesWithDwb?.some(site => site.id === siteId),
    lessonSelectedRow: lessons.lessonSelectedRow,
  }
}

GradeProgressDataContainer.propTypes = {
  bhuStatus: PropTypes.bool,
  className: PropTypes.string,
  classesNotStarted: PropTypes.number,
  dwbProgressBars: PropTypes.bool,
  grade: PropTypes.string,
  hasK8DwbAccess: PropTypes.bool,
  lessonSelectedRow: PropTypes.object,
  lessonsCompleted: PropTypes.number,
  numOfClasses: PropTypes.number,
  siteId: PropTypes.number,
  totalLessons: PropTypes.number,
}

export default connect(mapStateToProps, null)(GradeProgressDataContainer)
